import type { UrlParametersResponse } from '#shared/interfaces/top/urlParameters'
import { BFF_FETCH_RETRY_COUNT } from '@/constant/fetch'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path !== '/redirect') {
    return
  }
  const query = to.query
  if (query.catalog_id && Number(query.catalog_id)) {
    return navigateTo(`/model-grade/${query.catalog_id}`, { redirectCode: 301 })
  }
  const brand = String(query.brand ?? '')
  const car = String(query.car ?? '')
  if (!brand && !car) {
    return navigateTo('/', { redirectCode: 301 })
  }
  let urlParam = await getUrlParametersResponse(brand, car)
  if (brand && car && !urlParam) {
    urlParam = await getUrlParametersResponse(brand)
    if (urlParam) {
      return navigateTo(`/car-model-list?brand_cd=${urlParam.brand_cd}`, {
        redirectCode: 301,
      })
    }
  }

  if (!urlParam) {
    return navigateTo('/', { redirectCode: 301 })
  }
  if (brand && car && query.model && Number(query.model)) {
    return navigateTo(`/model-top/${urlParam.car_cd}_${query.model}`, {
      redirectCode: 301,
    })
  }
  if (brand && car) {
    return navigateTo(
      `/model-top/${urlParam.car_cd}_${urlParam.recent_model_cd}`,
      { redirectCode: 301 }
    )
  }
  if (brand) {
    return navigateTo(`/car-model-list?brand_cd=${urlParam.brand_cd}`, {
      redirectCode: 301,
    })
  }

  // 不正なクエリの場合はTOP画面にリダイレクト
  return navigateTo('/', { redirectCode: 301 })
})

/**
 * グーネットWEBのカタログからグーネットカタログミニアプリの画面に遷移できるようにURL構成の差異を取得
 * @param brand グーネットWEBのカタログのブランドディレクトリ文字列
 * @param car グーネットWEBのカタログの車種ディレクトリ文字列
 * @return {UrlParametersItem} グーネットカタログミニアプリのURLパラメータ
 */
const getUrlParametersResponse = async (brand: string, car: string = '') => {
  // リダイレクトして終わるため payload の受け手がおらず、useFetch にする利益が無い。
  // $fetch はステータス 400 以上で throw するが、ここは取得できなければ TOP へ倒す導線のため
  // 失敗を undefined に畳んで呼び出し側の判定に委ねる
  const urlParams = await $fetch<UrlParametersResponse>(
    '/api/catalogs/urlParameters',
    {
      cache: 'no-cache',
      retry: BFF_FETCH_RETRY_COUNT,
      query: {
        brand_dir: brand,
        car_dir: car,
      },
    }
  ).catch(() => undefined)
  // data配列は1つのため[0]を指定
  return urlParams?.data[0]
}
